import moment from 'moment'
import daterangepicker from 'daterangepicker'

$(function() {
    "use strict";
    let datePickerOptions = {
        singleDatePicker: true,
        showDropdowns: true,
        minDate: '01-01-2019',
        maxDate: '31-12-'+ parseInt(moment().add(5, 'y').format('YYYY'), 10),
        locale: {
            format: "DD-MM-YYYY",
            separator: " - ",
            applyLabel: "Aplicar",
            cancelLabel: "Cancelar",
            fromLabel: "DE",
            toLabel: "HASTA",
            customRangeLabel: "Custom",
            daysOfWeek: [
                "Dom",
                "Lun",
                "Mar",
                "Mie",
                "Jue",
                "Vie",
                "Sáb"
            ],
            monthNames: [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre"
            ],
            firstDay: 1
        }
    };
    $('.datepicker').each(function() {
        $(this).daterangepicker(datePickerOptions)
    })
})
